import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {Button, CircularProgress} from '@material-ui/core';

import {axiosInstance} from 'utils/auth.service';

import Stripe from './Stripe';
import PostFinance from './PostFinance';

const getPaymentMethodComponent = name => {
  switch (name) {
    case 'cinecheque':
      return () => <div>not supported payment</div>;
    case 'postfinance':
      return PostFinance;
    case 'card':
    case 'bancontact':
    default:
      return Stripe;
  }
};

const CommonPayment = ({amount, paymentMethod, couponCode, customerInfos, cinemaId, filmId, onClose, onSuccess}) => {
  const [paymentIntent, setPaymentIntent] = useState(null);

  const {t} = useTranslation();

  useEffect(() => {
    if (amount === 0 || paymentIntent) return;

    const startPaymentIntent = () => {
      const data = {
        failed_url: `${window.location.href}?paymentError`,
        success_url: `${window.location.href}?waitingPaymentConfirmation=${paymentMethod}`,
      };

      if (couponCode) {
        data.discount_code = couponCode;
      }

      if (customerInfos) {
        data.customer = customerInfos;
        console.log('customerInfos', customerInfos);
      }

      axiosInstance.post(`/cinemas/${cinemaId}/films/${filmId}/payment/${paymentMethod}`, data).then(res => {
        if (res.data.id && res.data.payment_profile?.paid) {
          onSuccess(res.data);
        } else {
          setPaymentIntent(res.data);
        }
      });
    };

    startPaymentIntent();
  }, [amount, paymentMethod, couponCode, customerInfos, cinemaId, filmId, onSuccess, paymentIntent]);

  const handleFreeRent = () => {
    const data = couponCode ? {discount_code: couponCode} : {};
    axiosInstance.post(`/cinemas/${cinemaId}/films/${filmId}/payment/${paymentMethod}`, data).then(res => {
      if (res.data.payment_profile?.paid) {
        onSuccess(res.data);
      }
    });
  };

  if (amount === 0) {
    return (
      <Button onClick={handleFreeRent} className="seance-btn" size="small" variant="contained" color="primary">
        {t('louer-gratuitement')}
      </Button>
    );
  }
  if (!paymentIntent) return <CircularProgress />;

  const PaymentMethodComponent = getPaymentMethodComponent(paymentMethod);

  return <PaymentMethodComponent paymentIntent={paymentIntent} onClose={onClose} />;
};

export default CommonPayment;
